<template>
    <div class="container">
        <div class="margin-top-10">
            <div class="display-flex justify-content-end">
                <!-- <div class="wrap-left">
                    <h3><strong>{{ dataElectronicLecture.name }}</strong></h3>
                </div> -->

                <div class="wrap-btn-add-chapter margin-10">
                    <a href="javascript:;"
                        class="item btn btn-main border-rd-20 font-size-16 display-flex-center item__add"
                        v-if="isEdit == 1" @click="isOpenModalCreateLearningTask = true">
                        Thêm nhiệm vụ học tập
                    </a>
                </div>
            </div>

            <div class="list-learning-task">
                <draggable :list="listLearningTaskLesson" @change="onChangeDrag" @start="onDragStart" @end="onDragEnd">
                    <transition-group type="transition">
                        <div class="row learning-task-item" v-for="(item, index) of listLearningTaskLesson"
                            :key="index">
                            <div class="col-md-6 margin-10">
                                <img class="icon-arrow" src="@/assets/img/arrow.png" v-if="item.isDragable" />
                                {{ item.name }}
                            </div>
                            <div class="list__actions justify-content-space-between display-flex">
                                <button v-if="!item.isDragable && isEdit == 1"
                                    class="btn btn-edit border-rd-20 font-size-16 form-30h display-flex-center justify-content-center line-height-1"
                                    :disabled="isLoading" @click="handleMoveTaskLesson(item)">
                                    Sửa
                                </button>
                                <button type="button" @click="handleDeleteTaskLesson(item)"
                                    class="btn btn-delete border-rd-20 font-size-16 form-30h display-flex-center justify-content-center line-height-1"
                                    :disabled="isLoading" v-if="isEdit == 1">
                                    Xóa
                                </button>
                            </div>
                        </div>
                    </transition-group>

                </draggable>

            </div>

            <div class="row pagination container m-0">
                <b-pagination pills v-model="paramQueryData.pageIndex" :total-rows="totalRecords"
                    :per-page="paramQueryData.pageSize" first-number last-number></b-pagination>
            </div>

            <ModalDeleteLearningTask @closeModal="isOpenModalDeleteLearningTask = false"
                v-if="isOpenModalDeleteLearningTask" @handleDeleteDone="handleDeleteDone"
                :learningTaskId="learningTaskId" />
            <ModalCreateLearningTask :subjectId="dataElectronicLecture.subjectId"
                @closeModal="isOpenModalCreateLearningTask = false" v-if="isOpenModalCreateLearningTask"
                @handleDone="handleDone" />
        </div>
    </div>
</template>
<script>
import ModalDeleteLearningTask from './ModalDeleteLearningTask';
import ModalCreateLearningTask from './ModalCreateLearningTask';
import { getListLearningTaskLesson, changeOrderUserLearningTask } from './../../../_api/learningTask'
import draggable from 'vuedraggable'
export default {
    components: {
        ModalDeleteLearningTask,
        ModalCreateLearningTask,
        draggable
    },

    props: {
        dataElectronicLecture: {
            type: Object,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: {}
        },
        type: {
            type: Number,
            default: 0
        },
        isEdit: {
            type: Number,
            default: 0
        },
    },

    mounted() {
        this.paramQueryData.lessonClassSchoolId = this.$route.query.id
        this.getListLearningTask()
        console.log(this.dataElectronicLecture)
    },

    // watch: {
    //     'learningTaskId': 'handleDeleteTaskLesson(item)'
    // },

    data() {
        return {
            isLoading: false,
            isOpenModalDeleteLearningTask: false,
            isOpenModalCreateLearningTask: false,
            learningTaskId: 0,

            paramQueryData: {
                lessonClassSchoolId: 0,
                keyword: '',
                pageIndex: 1,
                pageSize: 6,
                subjectId: 0,
                classId: 0
            },
            totalRecords: 0,
            listLearningTaskLesson: [],
        }
    },

    methods: {
        onChangeDrag(event) {
            //console.log(event)
        },
        onDragStart(event) {
            this.dragging = true
        },
        onDragEnd(event) {
            let listOrder = []
            console.log(this.listLearningTaskLesson)
            for (let i = 0; i < this.listLearningTaskLesson.length; i++) {
                const item = this.listLearningTaskLesson[i];
                listOrder.push(Number(item.orderNo))
            }

            listOrder.sort(function (a, b) {
                return a - b;
            })

            let listParams = []
            for (let i = 0; i < this.listLearningTaskLesson.length; i++) {
                const item = this.listLearningTaskLesson[i];
                listParams.push({ id: item.id, orderNo: listOrder[i] })
            }
            console.log(listParams)
            changeOrderUserLearningTask(listParams)

            for (let i = 0; i < this.listLearningTaskLesson.length; i++) {
                let element = this.listLearningTaskLesson[i];
                element.isDragable = false;
            }

            this.dragging = false
        },
        getListLearningTask() {
            let self = this
            getListLearningTaskLesson(self.paramQueryData).then(res => {
                if (res && res.data && !res.errors) {
                    self.listLearningTaskLesson = res.data.list
                    self.totalRecords = res.data.paging.totalRecords
                }
            })
        },
        handleMoveTaskLesson(item) {
            item.isDragable = !item.isDragable
        },
        handleDeleteTaskLesson(item) {
            this.isOpenModalDeleteLearningTask = true
            this.learningTaskId = item.id
        },

        handleDeleteDone() {
            this.filterDataByKeyword()
        },

        handleDone() {
            this.filterDataByKeyword()
        },

        filterDataByKeyword() {
            this.paramQueryData.pageIndex = 1
            this.getListLearningTask()
        },
    }
}
</script>

<style lang="scss" scoped>
.icon-arrow {
    width: 30px;
    height: 30px;
    cursor: pointer;
}

.justify-content-space-between {
    justify-content: space-between;
}

.btn-delete {
    background-color: red;
    color: white;
    margin-left: 5px;
    padding: 5px 30px;
}

.btn-edit {
    background-color: #7ea8c7;
    color: rgb(70, 69, 69);
    margin-left: 5px;
    padding: 5px 30px;
}

.margin-10 {
    margin: 10px 0;
}
</style>